module.exports = __webpack_public_path__ + "images/eq-black-playing.35502b663191d7bf310a5ab93b6eb99b.gif";